export default "__VITE_ASSET__DEUVK6pW__"